import * as i0 from '@angular/core';
import { inject, ElementRef, Directive, Input, NgModule } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

/**
 * @Deprecated this directive has been deprecated
 * */
class RemoveFromViewDirective {
    constructor() {
        this.#activatedRoute = inject(ActivatedRoute, { optional: true });
        this.#el = inject(ElementRef);
        /**
         * @Deprecated Unused input, will be removed in future version
         * */
        this.voIfNotApp = 'false';
    }
    #activatedRoute;
    #el;
    ngOnInit() {
        // to check query params for AppContainer test.
        this.#checkParamsForAppContainer();
        const sessionVal = JSON.parse(sessionStorage.getItem('webAppContainerCookies') ?? '');
        if (sessionVal?.isContainerInsideApp) {
            this.#el.nativeElement.remove();
        }
    }
    #checkParamsForAppContainer() {
        const { embeddedWebApp = '', utm_campaign: utmCampaign } = this.#activatedRoute?.snapshot?.queryParams || {};
        const isWebContainerInsideApp = embeddedWebApp.toLowerCase() === 'true';
        const isWebDeepLinkForLandlineTile = this.#activatedRoute?.snapshot?.params?.['uid'].toString().toLowerCase() === 'landline';
        if (isWebContainerInsideApp) {
            sessionStorage.setItem('webAppContainerCookies', JSON.stringify({
                isContainerInsideApp: isWebContainerInsideApp,
                isDeepLinkForMobileUser: /mobile_cus_app/gi.test(utmCampaign),
                isDeepLinkForCableUser: /cable_cus_app/gi.test(utmCampaign),
                isDeepLinkForLandlineTile: isWebDeepLinkForLandlineTile,
            }));
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.4", ngImport: i0, type: RemoveFromViewDirective, deps: [], target: i0.ɵɵFactoryTarget.Directive }); }
    static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "17.3.4", type: RemoveFromViewDirective, isStandalone: true, selector: "[voIfNotApp]", inputs: { voIfNotApp: "voIfNotApp" }, ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.4", ngImport: i0, type: RemoveFromViewDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[voIfNotApp]',
                    standalone: true,
                }]
        }], propDecorators: { voIfNotApp: [{
                type: Input
            }] } });

class RemoveFromViewModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.4", ngImport: i0, type: RemoveFromViewModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "17.3.4", ngImport: i0, type: RemoveFromViewModule, imports: [RemoveFromViewDirective], exports: [RemoveFromViewDirective] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "17.3.4", ngImport: i0, type: RemoveFromViewModule }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.4", ngImport: i0, type: RemoveFromViewModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [RemoveFromViewDirective],
                    exports: [RemoveFromViewDirective],
                }]
        }] });

/**
 * Generated bundle index. Do not edit.
 */

export { RemoveFromViewDirective, RemoveFromViewModule };
